<div class="content-section">
  <div class="title-div">
    <h2 class="background_title">{{ translationKeys.Authorization.ChangePassword | translate }}</h2>
  </div>
  <div>
    <form [formGroup]="changePasswordForm" autocomplete="off">
      <input autocomplete="off" name="hidden" type="text" style="display:none;">
      <!-- <dhhp-card class="card mb-3"> -->
      <mat-card style="box-shadow: none !important;">
        <div class="row mt-3 border-bottom">
          <div class="col-12 mb-3">
            <div class="col-12">
              <div class="form-group"><label>{{ translationKeys.Authorization.ChangePassword | translate }}</label>
                <p class="normal-text mt-1" style="word-break: break-word;">
                  {{ translationKeys.Authorization.ChangePasswordNotice | translate}}</p>
              </div>
            </div>
          </div>
          <!-- <div class="py-3">
                      <mat-divider></mat-divider>
                  </div> -->
        </div>
        <div class="row">
          <div class="col-12 mt-3">
            <div class="col-4 mb-3">
              <div class="form-group">
                <mat-form-field class="example-full-width">
                  <mat-label>{{ translationKeys.Authorization.CurrentPassword | translate }}</mat-label>
                  <input matInput inputSanitizer type="password" formControlName="currentPassword" maxlength="30"
                    name="currentPassword" id="currentPassword" required
                    placeholder="{{ translationKeys.Authorization.CurrentPassword | translate }} (Max 30)"
                    [ngClass]="{'is-invalid': submitted && f.currentPassword.errors}" [type]="hide2 ? 'password' : 'text'"
                    autofocus>
                </mat-form-field>
                <button class="password-buthide" mat-icon-button matSuffix (click)="hide2 = !hide2"
                  [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide2">
                  <mat-icon>{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <div *ngIf="submitted && f.currentPassword.errors" class="invalid-feedback">
                  <div *ngIf="f.currentPassword.errors.required">
                    {{ translationKeys.Authorization.CurrentPasswordRequiredError | translate }}</div>
                </div>
              </div>
            </div>
  
            <div class="col-4 mb-3">
              <mat-form-field class="example-full-width">
                <mat-label [ngClass]="{'invalid-message': showErrors}">{{ translationKeys.Authorization.NewPassword | translate }}</mat-label>
                <input matInput inputSanitizer type="password" formControlName="newPassword" maxlength="30"
                  name="newPassword" id="newPassword" required
                  placeholder="{{ translationKeys.Authorization.NewPassword | translate }} (Max 30)"
                  [type]="hide1 ? 'password' : 'text'" (keyup)="checkPassword($event.target.value)">
                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 30)</mat-hint>
              </mat-form-field>
              <button class="password-buthide" mat-icon-button matSuffix (click)="hide1 = !hide1"
                [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide1">
                <mat-icon>{{hide1 ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <div
                *ngIf="changePasswordForm.get('newPassword').errors && changePasswordForm.get('newPassword').touched && changePasswordForm.get('newPassword').errors.required"
                class="errormsg">
                {{ 'ERROR_MESSAGES.REQUIRED.PASSWORD_CHANGE.NEW' | translate }}</div>
              <div
                *ngIf="showErrors && (changePasswordForm.get('newPassword').touched || submitted) && (
                  errorMessageLength || errorMessageUpper || errorMessageLower || errorMessageNumber || errorMessageSpecial || errorMessageMarked || errorMessageTypo)">
                <p class="errormsg">{{ 'AUTHORIZATION.PASS_VERIFY.ERROR' | translate}}</p>
                <p class="errormsg" *ngIf="errorMessageLength">• {{ errorMessageLength | translate}}</p>
                <p class="errormsg" *ngIf="errorMessageUpper">• {{ errorMessageUpper | translate}}</p>
                <p class="errormsg" *ngIf="errorMessageLower">• {{ errorMessageLower | translate}}</p>
                <p class="errormsg" *ngIf="errorMessageNumber">• {{ errorMessageNumber | translate}}</p>
                <p class="errormsg" *ngIf="errorMessageSpecial">• {{ errorMessageSpecial | translate}}</p>
                <p class="errormsg" *ngIf="errorMessageSpecial">{{ specialCharacters }}</p>
              </div>
  
              <div *ngIf="errorMessageMarked">
                <p class="errormsg">{{ errorMessageMarked | translate}} {{firstMarkedChar}}</p>
              </div>
              <div *ngIf="errorMessageTypo">
                <p class="errormsg">{{ errorMessageTypo | translate}} {{firstTypoChar}}</p>
              </div>
            </div>
            <div class="col-4 mb-3">
              <mat-form-field class="example-full-width">
                <mat-label [ngClass]="{'invalid-message': confirmPassword}">{{ translationKeys.Authorization.ConfirmPassword | translate }}</mat-label>
                <input matInput inputSanitizer type="password" formControlName="confirmPasswordVal1" maxlength="30"
                  name="newPassword" id="newPassword" required
                  placeholder="{{ translationKeys.Authorization.ConfirmPassword | translate }} (Max 30)"
                  (keyup)="showStrengthLable($event.target.value)" [type]="hide ? 'password' : 'text'">
                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 30)</mat-hint>
              </mat-form-field>
              <button class="password-buthide" mat-icon-button matSuffix (click)="hide = !hide"
                [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <div class="errormsg"
                *ngIf="confirmPassword && (changePasswordForm.get('confirmPasswordVal1').dirty)">
                {{'ERROR_MESSAGES.CONFIRM_PASSWORD_MISMATCH'|translate}}
              </div>
              <div
                *ngIf="confirmPassword && (changePasswordForm.get('confirmPasswordVal1').touched || submitted)"
                class="invalid-feedback position-relative">
                <div
                  *ngIf=" changePasswordForm.get('confirmPasswordVal1').errors && changePasswordForm.get('confirmPasswordVal1').errors.required"
                  class="errormsg">
                  {{ 'ERROR_MESSAGES.REQUIRED.PASSWORD_CHANGE.CONFIRM' | translate }}</div>
              </div>
              <div class="mt-2">
                <ng2-password-strength-bar *ngIf="showLableView"
                  [passwordToCheck]="changePasswordForm.get('confirmPasswordVal1').value" [strengthLabels]="strengthLabels">
                </ng2-password-strength-bar>
              </div>
            </div>
            <!-- <div class="col-4 mb-3">
                                <mat-progress-bar mode="determinate" value="40"></mat-progress-bar>
                            </div> -->
            <div class="col-12 mb-3">
              <p class="col-12 p-0 d-flex" style="line-height:20px; word-break: break-word;">
                {{ translationKeys.Authorization.ChangePasswordHint |translate}}
              </p>
            </div>
          </div>
        </div>
      </mat-card>
      <!-- </dhhp-card> -->
      <div class="row m-0">
        <div class="col-12 mb-4 p-0 d-flex justify-content-end">
          <button class="btn-bd" (click)="passwordFun()">{{ translationKeys.Authorization.Save | translate }}</button>
        </div>
      </div>
    </form>
  </div>
</div>